import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AppContext';
import { Sparkles, ChevronRight } from 'lucide-react';

// /tools — directory of every AI tool that's been disclosed on AUDIVUE,
// sorted by usage volume. Each row links to /tools/{key}.
export const ToolsPage = () => {
  const { axiosInstance } = useAuth();
  const navigate = useNavigate();
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axiosInstance.get('/tools');
        if (!cancelled) setTools(r.data?.tools || []);
      } catch {
        if (!cancelled) setTools([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [axiosInstance]);

  return (
    <div className="min-h-screen bg-black pb-24" data-testid="tools-page">
      <div className="px-6 pt-6 pb-3">
        <div className="flex items-center gap-2 mb-2">
          <Sparkles className="w-5 h-5 text-white" />
          <h1 className="text-2xl font-bold text-white">AI Tools</h1>
        </div>
        <p className="text-sm text-zinc-500">Every AI tool disclosed on AUDIVUE, ranked by community usage.</p>
      </div>

      {loading && <div className="px-6 py-10 text-center text-zinc-500 text-sm">Loading…</div>}

      {!loading && tools.length === 0 && (
        <div className="px-6 py-10 text-center text-zinc-500 text-sm">
          No disclosed tools yet — once creators tag their AI tools, they'll show up here.
        </div>
      )}

      <div className="px-3 sm:px-6 mt-2 grid gap-2">
        {tools.map((t) => (
          <button
            key={t.key}
            onClick={() => navigate(`/tools/${t.key}`)}
            className="w-full flex items-center justify-between gap-3 p-3 rounded-xl bg-zinc-900/60 hover:bg-zinc-900 border border-zinc-800 transition-colors text-left"
            data-testid={`tool-row-${t.key}`}
          >
            <div className="flex items-center gap-3 min-w-0 flex-1">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-zinc-700 to-zinc-900 flex items-center justify-center flex-shrink-0">
                <Sparkles className="w-5 h-5 text-white/80" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-white truncate">{t.name}</p>
                {t.description && <p className="text-xs text-zinc-500 truncate">{t.description}</p>}
              </div>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <span className="text-xs text-zinc-500 font-mono">{t.video_count}</span>
              <ChevronRight className="w-4 h-4 text-zinc-600" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ToolsPage;
